window.addEventListener("theme:variant:change", variantChanged);
window.addEventListener("product:added", addItemToCart);

let variant_id = document.querySelector("#circuly-current-variant")?.innerHTML;
const meta_data = JSON.parse(
  document.querySelector("#circuly-meta-data")?.innerHTML?.replace(/\s/g, "")
);
// let payload = setPayload(variant_id, meta_data[variant_id]);
// !TODO meta subscription length ???

function setPayload(id, meta) {
  // console.log(meta?.subscription);
  let location = getSelectedLocation();
  console.log(location);
  return {
    sku: id || null,
    subscription: meta?.subscription ?? true,
    quantity: 1,
    location_id: location,
    subscription_period: "monthly",
    subscription_interval: meta?.subscription_interval || 1,
    subscription_duration: meta?.subscription_duration || null,
  };
}

function variantChanged(e) {
  const id = e.detail.variant.id;
  payload = setPayload(id, meta_data[id]);
}

function addItemToCart() {
  const url = window.location.href; // Gets the current URL
  const regex = /variant=(\d+)/;
  const match = url.match(regex);
  if (match) {
    variant_id = match[1];
  }
  let payload = setPayload(variant_id, meta_data[variant_id]);
  let addItemEvent = new CustomEvent("circuly-add-to-cart", {
    detail: {
      ...payload,
    },
  });
  dispatchEvent(addItemEvent);
}

function getSelectedLocation() {
  // get the select element
  let selectElement = document.querySelector("#enr_subscribe_plans");
  if (!selectElement) {
    return null;
  }
  // get the selected option element
  let selectedOption = selectElement.options[selectElement.selectedIndex];

  // get the value of the selected option
  let selectedValue = selectedOption.value;

  // extract the number from the selected value (assuming it's in the format "abo-<number>")
  let match = selectedValue.match(/abo-(\d+)/);
  let subscription_duration = match ? match[1] : null;
  console.log(subscription_duration);
  return subscription_duration;
}
